export default __webpack_public_path__ + "static/media/login.3bcb6567.wav";